import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/LanguageContext';
import { Loader2 } from 'lucide-react';

export function LanguageToggle() {
  const { language, setLanguage, isChanging } = useLanguage();

  // Show spinner on the target button (the one being switched TO)
  const pendingTarget = isChanging ? (language === 'en' ? 'zh' : 'en') : null;

  return (
    <div role="group" aria-label="Display language" className="flex rounded-lg bg-muted p-1 gap-1">
      <button
        onClick={() => setLanguage('en')}
        disabled={isChanging}
        aria-pressed={language === 'en'}
        className={cn(
          'flex-1 rounded-md px-3 py-1.5 text-xs font-medium transition-all',
          language === 'en'
            ? 'bg-primary text-primary-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground hover:bg-muted'
        )}
      >
        {pendingTarget === 'en' ? <Loader2 className="h-3 w-3 animate-spin mx-auto" /> : 'EN'}
      </button>
      <button
        onClick={() => setLanguage('zh')}
        disabled={isChanging}
        aria-pressed={language === 'zh'}
        className={cn(
          'flex-1 rounded-md px-3 py-1.5 text-xs font-medium transition-all',
          language === 'zh'
            ? 'bg-primary text-primary-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground hover:bg-muted'
        )}
      >
        {pendingTarget === 'zh' ? <Loader2 className="h-3 w-3 animate-spin mx-auto" /> : '中文'}
      </button>
    </div>
  );
}
